<template>
  <div class="add-remote-box">
    <el-dialog
      title="绑定演员"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      height="300px"
      custom-class="bind-actor-dialog"
    >
      <div class="remote-box">
        <el-input
          v-model="form.actor"
          placeholder="输入演员名称"
          class="input-with-select"
        >
          <!-- <el-select v-model="form.actor_id" slot="append" placeholder="请选择">
            <el-option label="全部" value="0"></el-option>
            <el-option label="演员1" value="1"></el-option>
            <el-option label="演员2" value="2"></el-option>
            <el-option label="演员3" value="3"></el-option>
          </el-select> -->
        </el-input>
      </div>
      <!-- <div class="remote-visual">
        <div class="visual-list">
          <div
            v-for="item in remoteVisualOptions"
            :key="item.id"
            :class="['visual-item', { selected: selectedVisual === item.id }]"
            @click="toggleVisual(item.id)"
          >
            {{ item.name }}
            <i
              v-if="selectedVisual === item.id"
              class="el-icon-check checkmark"
            ></i>
          </div>
        </div>
      </div> -->
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="handleClose" size="small" type="danger">确认解绑</el-button> -->
        <el-button type="primary" @click="editActor" size="small">确认绑定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";

export default {
  data() {
    return {
      dialogVisible: false,
      form: {
        ids: [],
        actor: "",
      },
      remoteVisualOptions: [
        { id: 1, name: "远程视觉 - 七七UI" },
        { id: 2, name: "远程视觉 - 六六UI" },
        { id: 3, name: "远程视觉 - 五五UI" },
        { id: 4, name: "远程视觉 - 四四UI" },
        { id: 5, name: "远程视觉 - 三三UI" },
      ],
      selectedVisual: null,
    };
  },
  methods: {
    // 打开弹窗并赋值需要修改
    open(videoIds) {
      this.dialogVisible = true;
      this.form.ids = videoIds || [];
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.form.ids = [];
      this.form.actor = "";
    },
    editActor() {
      if (!this.form.actor)
        return this.$message.error("请输入演员名称");
      let req = {
        ids: this.form.ids,
        actor: this.form.actor,
      };
        API.batchUpdateTag(req)
          .then((res) => {
            if (res.code === 0) {
              this.$message({
                message: "编辑成功！",
                type: "success",
              });
              this.$emit("handlerClose");
              this.$emit("handlerSave");
            } else {
              this.$message.error("编辑失败！");
            }
            this.handleClose();
          })
          .catch(() => {
            this.handleClose();
          });
    },
  },
};
</script>

<style scoped lang="scss">
.add-remote-box {
  .remote-visual,
  .remote-operation {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .el-select {
      width: 100%;
    }
    .visual-list {
      width: 100%;
      max-height: 200px;
      overflow-y: auto;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      padding: 5px;
      .visual-item {
        padding: 8px 12px;
        margin: 2px 0;
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.3s;
        border: 1px solid transparent;
        user-select: none;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        &:hover {
          background-color: #f5f7fa;
        }
        &.selected {
          background-color: #409eff;
          color: white;
          border-color: #409eff;
        }
        .checkmark {
          font-size: 16px;
          font-weight: bold;
        }
      }
    }
  }
  .priority {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 15px 0;
    span {
      margin-right: 10px;
      width: 100px;
    }
    .el-radio {
      margin-right: 10px;
    }
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    .el-button {
      width: 100px;
    }
  }
  :deep(.bind-actor-dialog) {
    height: auto !important;
  }
}
</style>

<!-- <style lang="scss">
.input-with-select {
  .el-input-group__append {
    width: 100px !important;
    background-color: #fff !important;
  }
}
</style> -->